import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { BackendHealthService } from './backend-health.service';
import { HealthCheckHttpService } from './health-check-http.service';

@Injectable()
export class BackendHealthInterceptor implements HttpInterceptor {
  constructor(
    private readonly healthCheckService: HealthCheckHttpService,
    private readonly backendHealthService: BackendHealthService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.examdojo.examdojoApiUrl)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status >= 500 && error.status < 600) {
            // Call the health check endpoint to verify if the API is really down
            return this.healthCheckService.checkHealth().pipe(
              switchMap((isHealthy) => {
                if (!isHealthy) {
                  this.backendHealthService.reportUnhealthyCall();
                }
                return throwError(() => error);
              }),
            );
          }
        }

        return throwError(() => error);
      }),
    );
  }
}
